import React from 'react';

import { Btn } from '../shared/Btn';

import "../../../css/components/services/service-card.scss";
export function ServiceCard(props) {
  console.log(props);

  const {
    name,
    description,
    image,
    link,
  } = props.service;

  return (
    <div className="service-card">
      <div className="image-wrapper">
        <img className="service-image" src={ `images/services/${image}` } alt="" />
      </div>
      <div className="card-content">
        <div className="name">
          <div className="text">
            { name }
          </div>
          <div className="underline-wrapper"></div>
        </div>
        <div className="description">
          { description }
        </div>
      </div>

      <Btn href={ link } className="blue learn-more">
        Learn More
      </Btn>
    </div>
  );
}